<template>
<div class="mySign">
  <div class="sign-top">
        <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
        <div>我的签约</div>
        <div></div>
  </div>
  <div style="height:100%">
    <van-tabs v-model="singId.signStatus" @click="ontabChange" style="padding-bottom:45px">
      <van-tab title="待签约" name="1">
         <div class="noQianshu" v-if="qianshuList.length==0">
            <img :src="qianshu" alt="">
        </div>
        <div class="sing" v-for="(item, key) in qianshuList" :key="key">
          <div class="sing-left">
            <div class="sing-left-title">
              <span></span>
              <span class="title">自由职业者服务协议</span>
            </div>
            <div class="sing-left-cont">
              <span>{{item.companyName}}</span>
              <span class="line"></span>
              <span style="margin-left:5px">{{item.userName}}</span>
            </div>
            <div class="sing-left-time">签约完成时间 {{item.signEndTime}}</div>
          </div>
          <div class="sing-right" @click="checkContract">
            <a v-if="!item.signUrl">合同生成中</a>
            <a v-else :href="item.signUrl">签署合同</a>
          </div>
        </div>

      </van-tab>
      <van-tab title="已签约" name="2">
        <div class="noQianshu" v-if="qianshuList.length==0">
            <img :src="qianshu" alt="">
        </div>
        <div class="sing" v-for="(item, key) in qianshuList" :key="key">
          <div class="sing-left">
            <div class="sing-left-title">
              <span></span>
              <span class="title">自由职业者服务协议</span>
            </div>
            <div class="sing-left-cont">
              <span>{{item.companyName}}</span>
              <span class="line"></span>
              <span style="margin-left:5px">{{item.userName}}</span>
            </div>
            <div class="sing-left-time">签约完成时间 {{item.signEndTime}}</div>
          </div>
          <div class="sing-right">
            <a v-if="!item.contractUrl">合同生成中</a>
            <a v-else :href="item.contractUrl">查看合同</a>
          </div>
        </div>
      </van-tab>
      <van-tab title="已失效" name="3">
        <div class="noQianshu" v-if="qianshuList.length==0">
            <img :src="qianshu" alt="">
        </div>
        <div class="sing" v-for="(item, key) in qianshuList" :key="key">
          <div class="sing-left">
            <div class="sing-left-title">
              <span></span>
              <span class="title">自由职业者服务协议</span>
            </div>
            <div class="sing-left-cont">
              <span>{{item.companyName}}</span>
              <span class="line"></span>
              <span style="margin-left:5px">{{item.userName}}</span>
            </div>
            <div class="sing-left-time" v-if="item.signEndTime">失效时间 {{item.signEndTime}}</div>
            <div class="sing-left-time" v-else>终止</div>
          </div>
          <div class="sing-right" style="color:red">
            已失效
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 分页 -->
    <div class="footer" v-if="qianshuList.length!==0">
      <van-pagination v-model="singId.currentPage" :total-items="pageCount" mode="simple" @change="ontabChange" />
    </div>
  </div>
</div>
</template>
<script>
import http from "../../api/index.js";
import config from "../../utils/config";
export default {
  data(){
    return{
      singId:{
        signStatus:1,
        currentPage:1,
        pageSize:10
      },
      pageCount:0,
      qianshuList:[],
      qianshu:require("../../assets/img/qianshu.png"),
    }
  } ,
  mounted(){

    this.fetchMySing();
  },
  methods:{
    fetchMySing(){
      http.post(config.mySign,this.singId).then(({code,data,message})=>{
        if(code==0){
          this.qianshuList=data.rows;
        }else{
          this.$toast.fail(message)
        }
      })
    },
    goBack(){
      this.$router.go(-1)
    },
    ontabChange(){
      this.fetchMySing()
    },
    checkContract(){
    }
  },
}
</script>
<style lang="less" scoped>
.mySign{
  text-align: left;
  height: 100%;
  width: 100%;
  background: #f8f8f8;
  .noQianshu{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
    padding-top:150px;
    img{
      width: 50%;
      height: auto;
    }
  }
  .sing{
    display: flex;
    justify-content: space-between;
    align-items: center ;
    padding: 20px;
    background: #ffffff;
    margin-top: 20px;
    .sing-left{
      .sing-left-title{
        margin-bottom: 20px;
        .title{
          font-size: 30px;
        }

      }
      .sing-left-cont{
        font-size: 26px;
        color: #A4A4A4;
        position: relative;
        .line{
          width: 2px;
          height: 22px;
          position: absolute;
          top:8px;
          display: inline-block;
          background: #A4A4A4;
        }
      }
      .sing-left-time{
        font-size: 26px;
        color: #A4A4A4;
      }
    }
    .sing-right{
      a{
        color: #2987c1;
      }
    }
  }
  .sign-top{
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 35px;
    padding:20px 0;
    .jian{
    font-size: 35px;
  }

  }
  .footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #ffffff;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/mySign/index.vue